import styled from 'styled-components'

export const WrappedComponentContainer = styled.div`
  position: relative;
`

export const SelectedItemLabel = styled.div`
  color: var(--Foreground-Neutral, #14171f);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    flex: 1;
    color: var(--Foreground-Neutral, #14171f);

    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
  }
`

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const ItemLabel = styled.div<{ selected?: boolean }>`
  color: var(--Foreground-Neutral, #14171f);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    flex: 1;

    color: ${({ selected }) =>
      selected
        ? 'var(--Foreground-Primary, var(--Foreground-Primary, #4D4BE7))'
        : 'var(--Foreground-Neutral, #14171f)'};

    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
  }
`

export const IconContainer = styled.div`
  width: 38px;
`

export const FilePreviewContainer = styled.div`
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;
`

export const FilePreview = styled.img`
  width: 24px;
  height: 24px;

  border-radius: 2px;
`

export const SpanFilePreview = styled.div`
  position: absolute;
  bottom: -3px;
  right: -3px;

  display: flex;
  justify-content: center;
  align-items: center;

  width: 10px;
  height: 10px;

  background-color: var(--Background-Neutral-faded, #f3f4f6);

  border-radius: 50%;

  border: 1px solid white;

  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1), 0px 2px 3px rgba(0, 0, 0, 0.1);
`
